// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  BaseReadAllDto,
  GameReturnDto,
  IBaseArrayResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class GameService {
  /**
   * GET /api/game
   */
  readAll(
    dto: BaseReadAllDto,
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<GameReturnDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/game';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      configs.params = dto;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
